import React, { useCallback, useEffect, useState } from "react";
import { Accommodations } from "./components/Accommodations";
import { Amenities } from "./components/Amenities";
import { EditorialIntro } from "./components/EditorialIntro";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { Hero } from "./components/Hero";
import { IntroOverlay } from "./components/IntroOverlay";
import { Location } from "./components/Location";
import { Moments } from "./components/Moments";
import { Reservation } from "./components/Reservation";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { SocialProof } from "./components/SocialProof";
import { Testimonials } from "./components/Testimonials";
export function App() {
  const [showIntro, setShowIntro] = useState(() => {
    try {
      return sessionStorage.getItem("casa-das-tartarugas-intro") !== "vista";
    } catch {
      return true;
    }
  });
  useEffect(() => {
    document.documentElement.lang = "pt-BR";
    document.title = "Casa das Tartarugas | Hospedagem em Angra dos Reis";
    const description = "Casa das Tartarugas: uma hospedagem acolhedora em Marinas, Angra dos Reis. Consulte disponibilidade diretamente pelo WhatsApp.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  useEffect(() => {
    document.body.style.overflow = showIntro ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showIntro]);
  const handleHeroReady = useCallback(() => {
    if (!showIntro) return;
    try {
      sessionStorage.setItem("casa-das-tartarugas-intro", "vista");
    } catch {/* A experiência continua sem armazenamento. */}
    setShowIntro(false);
  }, [showIntro]);
  return <div className="min-h-screen w-full overflow-x-clip bg-[#F7F4ED] font-sans text-[#172B32] antialiased" data-id="element-0" data-mp="swqc3h7othxg">
      <a href="#conteudo" className="fixed left-4 top-4 z-[110] -translate-y-24 bg-white px-4 py-3 font-semibold text-[#033448] transition-transform focus:translate-y-0" data-id="element-1" data-mp="38b5stwojqcx">Pular para o conteúdo</a>
      <IntroOverlay visible={showIntro} data-id="element-2" data-mp="d2l7513lnyzs" />
      <SiteHeader data-id="element-3" data-mp="85bbv4tj4t41" />
      <main id="conteudo" data-id="element-4" data-mp="86w6eufugc1w">
        <Hero onImageReady={handleHeroReady} data-id="element-5" data-mp="83i39jzcvyte" />
        <SocialProof data-id="element-6" data-mp="3gkuy3jvs9b9l" />
        <EditorialIntro data-id="element-7" data-mp="3gm63tp8sgt3c" />
        <Moments data-id="element-8" data-mp="3glo2wfb6lqp3" />
        <Accommodations data-id="element-9" data-mp="3gj1w4hw47f7x" />
        <Amenities data-id="element-10" data-mp="3bmtgl3e09k08" />
        <Testimonials data-id="element-11" data-mp="3bncso3gz5e6c" />
        <Location data-id="element-12" data-mp="3bo4mp9uxb3ui" />
        <Reservation data-id="element-13" data-mp="3bkgss9lkgff9" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3qbfwp7bgifsi" />
      <FloatingWhatsApp data-id="element-15" data-mp="3qbzg6sgr9c8n" />
    </div>;
}